import React, { ComponentProps } from 'react';

import styled from 'styled-components';

import theme from '@adsk/alloy-react-theme';

import TableConfigurationColumns, {
  TableConfigurationColumnsProps,
} from './Columns';
import TableConfigurationDensity from './Density';
import TableConfigurationReset from './Reset';

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.charcoal200};
`;

export type DefaultMenuContentProps<D extends Record<string, unknown>> = Omit<
  ComponentProps<typeof TableConfigurationDensity>,
  'label'
> & {
  densityLabel: ComponentProps<typeof TableConfigurationDensity>['label'];
} & Omit<ComponentProps<typeof TableConfigurationReset>, 'label'> & {
    resetLabel: ComponentProps<typeof TableConfigurationReset>['label'];
  } & TableConfigurationColumnsProps<D>;

const DefaultMenuContent = <D extends Record<string, unknown>>({
  handleToggleColumn,
  isColumnReorderable,
  handleOnDragEnd,
  validColumns,
  densityLabel,
  setSize,
  resetLabel,
  reset,
}: DefaultMenuContentProps<D>) => (
  <div css={[{ minWidth: 280, paddingTop: '8px' }]}>
    <TableConfigurationColumns<D>
      handleToggleColumn={handleToggleColumn}
      handleOnDragEnd={handleOnDragEnd}
      validColumns={validColumns}
      isColumnReorderable={isColumnReorderable}
    />
    <Separator />
    <TableConfigurationDensity label={densityLabel} setSize={setSize} />
    <Separator />
    <TableConfigurationReset label={resetLabel} reset={reset} />
  </div>
);

export default DefaultMenuContent;
